// extracted by mini-css-extract-plugin
module.exports = {"Screenshot":"Screenshots_Screenshot__13-v_","ScreenshotContainer":"Screenshots_ScreenshotContainer__2vyS1","ScreenshotLink":"Screenshots_ScreenshotLink__uN6KD"};